import React from 'react';

import { FLOATING_UI_DOM_ID } from '../../constants';

/**
 * The element a modal renders for the floating surfaces opened inside it. `null` while that element
 * is mounting, `undefined` outside a modal.
 */
export const FloatingPortalRootContext = React.createContext<HTMLElement | null | undefined>(undefined);

/**
 * The `FloatingPortal` target for a floating surface: the enclosing modal's floating root, so the
 * surface stacks above the modal and stays inside the modal's accessible subtree, or the page's
 * floating-ui root outside a modal.
 *
 * A `null` root makes `FloatingPortal` wait for it rather than fall back to the page root.
 */
export function useFloatingPortalTarget(): { root: HTMLElement | null } | { id: string } {
  const root = React.useContext(FloatingPortalRootContext);
  if (root === undefined) return { id: FLOATING_UI_DOM_ID };
  return { root };
}
